import Vue from 'vue'
import VuejsDatePicker from 'vuejs-datepicker'

Vue.component('datepicker', VuejsDatePicker)
